import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";

const LocationModelPopup = ({ onSave, locationData, isEditing }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (isEditing && locationData) {
      setValue("location_name", locationData.location);
      setValue("email", locationData.email);
      setValue("address", locationData.address);
      setValue("city", locationData.city);
      setValue("state", locationData.state);
      setValue("zip", locationData.zip);
      setValue("currency", locationData.currency);
      setValue("status", locationData.status);
    } else {
      reset();
    }
  }, [isEditing, locationData, reset, setValue]);

  const onSubmit = async (data) => {
    try {  
      const url = isEditing
        ? `${apiUrl}/company/edit-locations/${locationData.id}`
        : `${apiUrl}/company/add-locations`;
      const method = isEditing ? "put" : "post";
      const response = await axios[method](url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(`Location ${isEditing ? "updated" : "added"} successfully`);
      onSave(response.data);
      reset();
      document.querySelector('[data-bs-dismiss="modal"]').click(); // Close the modal
    } catch (error) {
      toast.error(
        `Failed to ${isEditing ? "update" : "add"} location. Please try again later.`
      );
    }
  };

  return (
    <div id="add_location" className="modal custom-modal fade" role="dialog">
      <div
        className="modal-dialog modal-lg"
        style={{
          margin: 0,
          position: "fixed",
          right: 0,
          height: "100vh",
          width: "50%",
        }}
      >
        <div className="modal-content h-100 d-flex flex-column">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="d-flex flex-column h-100"
          >
            <div className="modal-header">
              <h5 className="modal-title">
                {isEditing ? "Edit Location" : "Add Location"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div
              className="modal-body flex-grow-1 overflow-auto"
              style={{ maxHeight: "calc(100vh - 120px)" }}
            >
              <div className="scrollable-container">
                {/* Location Name */}
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Location Name <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("location_name", {
                        required: "Location Name is required",
                      })}
                    />
                    {errors.location_name && (
                      <span className="text-danger">
                        {errors.location_name.message}
                      </span>
                    )}
                  </div>
                </div>

                {/* Email */}
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="email"
                      {...register("email", {
                        required: "Email is required",
                      })}
                    />
                    {errors.email && (
                      <span className="text-danger">{errors.email.message}</span>
                    )}
                  </div>
                </div>

                {/* Address */}
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">Address</label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("address")}
                    />
                  </div>
                </div>

                {/* City */}
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">City</label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("city")}
                    />
                  </div>
                </div>

                {/* State */}
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">State</label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("state")}
                    />
                  </div>
                </div>

                {/* ZIP */}
                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">ZIP</label>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      {...register("zip")}
                    />
                  </div>
                </div>

                

                {/* Status */}
          
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button className="btn btn-primary submit-btn" type="submit">
                {isEditing ? "Save Changes" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LocationModelPopup;
